<template>
  <div class="error-page container">
    <div class="col-md-8">
      <h3>Ошибка 500</h3>
        <p>Страница временнно недоступна.</p>
        <p><router-link to='/'>Вернуться на&nbsp;главную.</router-link></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'serverPage',
  metaInfo() {
    return {
      title: 'Ошибка сервера',
      meta: [{
        name: 'prerender-status-code',
        content: '404',
      }],
    };
  },
};
</script>

<style>
  .error-page{
    padding: 10vh 50px;

    @media (max-width: 600px){
      padding: 10px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// ServerError.vue?78b1e60e